import { SCROLLREFRESH, ALERT } from './app.config';
import { Scroller, Footer, Cursor } from './animations';
import { Page, Resizer, Alert } from './shared';
import Routing from './transitions/routing.js';
import Nav from './nav/nav.js';
import gsap from '@gsap/business';
import Panels from './nav/panels.js';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

//css
import '../scss/main.scss';

export default class App extends Page {

	constructor(el) {
		super(el);
		this.init();
		this.initAnimations();
		this.initRouting();
    this.exportMethods();
    this.customSelect();
	}

	initAnimations() {
		this.scroller = new Scroller();
    this.navigation = new Nav(this.nav, this.scroller);
		this.footer = new Footer();
    this.cursor = new Cursor(this.body, this.scroller);
    this.resizer = new Resizer(this.body, this.onBodyResize);
    this.panels = new Panels();
    this.isMobile && ScrollTrigger.normalizeScroll(true);

    if (!ALERT) return;
    const alert = this.body.querySelector('[data-alert]');
    alert && new Alert(alert);
    //ScrollTrigger.normalizeScroll(true);
	}

	initRouting() {
		this.routingManager = new Routing();
		this.routingManager.init(this.header, this.scroller);
	}

  onBodyResize({width, height}) {
    SCROLLREFRESH && ScrollTrigger.refresh();
  }

  exportMethods() {
    window.client = {
      scroller: {
        start: () => this.scroller.start(),
        stop: () => this.scroller.stop(),
        toggle: () => this.scroller.toggle(),
        refresh: () => {
          SCROLLREFRESH && ScrollTrigger.refresh()
        },
      }
    }
  }

  customSelect() {
    if (window.jQuery) {
      console.log('JQUERY LOADED'); 
      jQuery(".chosen-select").chosen({ no_results_text: "- - -"});

      
      jQuery(".uacf7_repeater_button_wraper").on( "click", function() {
        console.log('clicked');
        var button = jQuery(this) ;
        button.parent().parent().find('.chosen-container:last').remove();
        function saluta() {
          
          button.parent().parent().find('.chosen-select:last').show().chosen({ no_results_text: "- - -"});
          //jQuery(".chosen-select").chosen("destroy");
        }
        
        setTimeout(saluta, 500);

        
      });



    } else {
      console.log("no-jquery");
    }
  }
}

window.onload = () => {
	const app = new App();
};

